// src/utils/partnerValidator.js

// Basic rules tuned for India-style mobile numbers and common emails.
// Tweak as needed for your business rules.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

const MOBILE_RE = /^(?:(?:\+?91[-\s]?)?(?:0)?)?[6-9]\d{9}$/; // accepts 10-digit starting 6-9, with optional +91/0

// const CODE_RE = /^[A-Z0-9_-]{3,20}$/; // 3–20 chars, uppercase letters/digits/_/-

/**
 * Validate partner payload for add/update.
 * @param {Object} values - { partner_code, name, email, mobile_number }
 * @param {Object} opts
 *  - mode: "add" | "update"
 *  - existing: array of existing partners (for uniqueness checks)
 *  - currentId: id of the row being edited (to ignore itself on update)
 *  - requireEmail: boolean (default true)
 *  - requireMobile: boolean (default true)
 */
export function validatePartner(values, opts = {}) {
  const {
    mode = "add",
    existing = [],
    currentId = null,
    requireEmail = true,
    requireMobile = true,
  } = opts;

  const errors = {};

  // partner_code
  // const code = String(values.partner_code || "").trim();
  // if (!code) {
  //   errors.partner_code = "Partner code is required.";
  // } else if (!CODE_RE.test(code)) {
  //   errors.partner_code =
  //     "Partner code must be 3–20 chars (A–Z, 0–9, _ or -). Use uppercase.";
  // } else {
  //   const clash = existing.find(
  //     (p) =>
  //       String(p.partner_code || "").trim().toUpperCase() === code.toUpperCase() &&
  //       (mode === "add" ? true : String(p.id) !== String(currentId))
  //   );
  //   if (clash) errors.partner_code = "Partner code already exists.";
  // }
  const code = String(values.partner_code || "").trim();
  if (!code) {
    errors.partner_code = "Partner code is required.";
  }

  // name
  const name = String(values.name || "").trim();
  if (!name) {
    errors.name = "Name is required.";
  } else if (name.length < 2) {
    errors.name = "Name must be at least 2 characters.";
  }

  // email
  const email = String(values.email || "").trim();
  if (requireEmail || email) {
    if (!email) {
      errors.email = "Email is required.";
    } else if (!EMAIL_RE.test(email)) {
      errors.email = "Enter a valid email address.";
    } else {
      const clash = existing.find(
        (p) =>
          String(p.email || "")
            .trim()
            .toLowerCase() === email.toLowerCase() &&
          (mode === "add" ? true : String(p.id) !== String(currentId))
      );
      if (clash) errors.email = "Email already exists.";
    }
  }

  // mobile_number
  const mobile = String(values.mobile_number || "").trim();
  if (requireMobile || mobile) {
    if (!mobile) {
      errors.mobile_number = "Mobile number is required.";
    } else if (!MOBILE_RE.test(mobile)) {
      errors.mobile_number =
        "Enter a valid 10-digit Indian mobile (optionally with +91/0).";
    } else {
      // normalize to last 10 digits for uniqueness comparisons
      const last10 = mobile.replace(/\D/g, "").slice(-10);
      const clash = existing.find((p) => {
        const m = String(p.mobile_number || "");
        const mLast10 = m.replace(/\D/g, "").slice(-10);
        return (
          mLast10 &&
          mLast10 === last10 &&
          (mode === "add" ? true : String(p.id) !== String(currentId))
        );
      });
      if (clash) errors.mobile_number = "Mobile number already exists.";
    }
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors,
  };
}
